import React from 'react'
import Image from 'next/image'
import { useTranslation } from '@mc/i18n'
import { cloudflareLoader } from '@mc/image-cloudflare'
import { SignUpButton } from 'pages/certificates/components/SignUpButton'
import { TrackingAttributes } from 'pages/certificates/tracking'

interface CalloutProps {
  currentCertificateTitle: string
  currentCertificateImg?: { url?: string; altText?: string }
  enrollDate?: string | null
  signupEnabled?: boolean
}

export const CertificateCallout = ({
  currentCertificateTitle,
  currentCertificateImg,
  signupEnabled,
}: CalloutProps) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div className='container d-flex flex-column flex-fill justify-content-end mc-py-4 mc-px-1'>
      <div className='d-flex flex-column align-items-center mc-bg-container-tint-medium mc-p-4 mc-corners--md'>
        {currentCertificateImg?.url && (
          <div className='mc-mb-4'>
            <Image
              src={currentCertificateImg.url}
              alt={currentCertificateImg.altText || ''}
              width={320}
              height={180}
              className='mc-corners--md mc-w-100'
              loader={cloudflareLoader}
              style={{
                aspectRatio: '16/9',
                objectFit: 'cover',
              }}
            />
          </div>
        )}

        <h2 className='mc-text-h7 mc-mb-2 c-text-color--light mc-opacity--muted'>
          {t('certificatesMenuMobile.masterClassCertificates')}
        </h2>
        <p className='mc-text-h5 mc-mb-5 mc-text--center c-text-color--light '>
          {currentCertificateTitle}
        </p>
        {signupEnabled && (
          <div className='d-flex flex-column flex-gap-3 justify-content-between align-items-center mc-w-100'>
            <TrackingAttributes location='dropdown-navigation'>
              <SignUpButton
                className='flex-1'
                onClick={(e) => e.stopPropagation()}
                fullWidth
                style={{
                  maxWidth: '250px',
                }}
              />
            </TrackingAttributes>
          </div>
        )}
      </div>
    </div>
  )
}
